var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDefence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{clip-path:url(#SVGID_00000052815212213361844140000016998996269264213387_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shield-alt",
    d: "M44.95,8.17L26.2,0.36c-1.15-0.48-2.45-0.48-3.61,0L3.85,8.17C2.1,8.9,0.96,10.6,0.96,12.5 c0,19.39,11.18,32.79,21.63,37.14c1.15,0.48,2.45,0.48,3.61,0c8.37-3.48,21.64-15.53,21.64-37.14C47.83,10.61,46.7,8.9,44.95,8.17z  M24.39,43.59V6.38l17.18,7.16c-0.32,14.79-8.02,25.5-17.17,30.05L24.39,43.59z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefence);
export default __webpack_public_path__ + "static/media/Icon_Defence.326172a27fa75598b07d385e0b4cd4a3.svg";
export { ForwardRef as ReactComponent };